function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Loader from "../Loader/Loader";
import { useTable, useSortBy } from "react-table";
import { HiDownload } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import classNames from "classnames";
import "./WorkActivityLog.css";
import { HiOutlineSelector, HiChevronDown, HiChevronUp } from "react-icons/hi";
import { BREAK_TIME_SUMMARY_QUERY, BREAK_TIME_SUMMARY_EXPORT_QUERY } from "./query";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Dropdown from "react-bootstrap/Dropdown";
import Tooltip from "react-bootstrap/Tooltip";
var _require = require("../utils"),
  convertSecToHoursAndMinutesAndSecWithTextShortForm = _require.convertSecToHoursAndMinutesAndSecWithTextShortForm;
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { arrayToStringOutput, startOfDayCheck, endOfDayCheck } from "../SideMenu/Header";
import { TimeFilter } from "../ProjectReport/DateFilter";
import { USER_LISTING_QUERY } from "../DailyAttendance/query";
import { MultiSelect } from "react-multi-select-component";
import { PlanUpgradeMessage } from "../WorkLoadAnalysisReport/WorkLoadAnalysisReport";
import Select from "react-select";
var LIMIT = 20;
var offsets = 0;
var WorkActivityLog = function WorkActivityLog(props) {
  var _userListData$getUser2, _breakTimeSummaryData, _breakTimeSummaryData2, _breakTimeSummaryData3, _breakTimeSummaryData4, _breakTimeSummaryData5;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isAllLoaded = _React$useState2[0],
    setIsAllLoaded = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoadingMore = _React$useState4[0],
    setIsLoadingMore = _React$useState4[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    userParameterCheck = _React$useState6[0],
    setUserParameterCheck = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    exportButton = _React$useState8[0],
    setExportButton = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isNavClick = _React$useState10[0],
    setNavClick = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    userActive = _React$useState12[0],
    setUserActive = _React$useState12[1];
  var _React$useContext = React.useContext(FilterContext),
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var _React$useState13 = React.useState({
      startDate: startOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().startOf("days").toDate() : endOfDayCheck(currentTimezone, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone) ? moment().tz(currentTimezone).clone().endOf("days").toDate() : moment().tz(currentTimezone).clone().toDate(),
      endDate: null
    }),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    dates = _React$useState14[0],
    setDate = _React$useState14[1];
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var filterData = arrayToStringOutput([startDate, endDate], organisationSettings.organisationTimezone);
  var _React$useState15 = React.useState(0),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    loopInit = _React$useState16[0],
    setLoopInit = _React$useState16[1];
  var _React$useState17 = React.useState([]),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    allUsersData = _React$useState18[0],
    setAllUsersData = _React$useState18[1];
  var filterDaysDiff = Math.ceil(moment.duration(moment(endDate).diff(startDate)).asDays());
  var exportLimit = filterDaysDiff >= 15 && userActive.length >= 100 ? 50 : 0;
  var loopCount = exportLimit != 0 ? Math.ceil(userActive.length / exportLimit) : 1;
  var userList = [];
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var _useQuery = useQuery(USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: "all",
        userRole: role
      },
      skip: !organisationId
    }),
    userListData = _useQuery.data,
    userListError = _useQuery.error,
    userListLoading = _useQuery.loading,
    userListRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(BREAK_TIME_SUMMARY_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: "all",
        userId: userActive.length ? userActive : null,
        startDate: Number(moment(startDate).format("x")),
        endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        limit: LIMIT,
        offset: 0,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
      },
      skip: !organisationId
    }),
    breakTimeSummaryData = _useQuery2.data,
    breakTimeSummaryError = _useQuery2.error,
    breakTimeSummaryLoading = _useQuery2.loading,
    fetchMore = _useQuery2.fetchMore,
    breakTimeSummaryRefetch = _useQuery2.refetch;
  var _useLazyQuery = useLazyQuery(BREAK_TIME_SUMMARY_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  React.useEffect(function () {
    if (userListData !== null && userListData !== void 0 && userListData.getUserListing.length && userActive.length == 0) {
      var _userListData$getUser;
      setUserActive([userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListing[0]) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.userId]);
    }
  }, [userListData]);
  React.useEffect(function () {
    if (userActive.length) {
      breakTimeSummaryRefetch === null || breakTimeSummaryRefetch === void 0 ? void 0 : breakTimeSummaryRefetch();
    }
  }, [userActive]);
  React.useEffect(function () {
    setIsAllLoaded(false);
  }, [breakTimeSummaryData]);
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser2 = userListData.getUserListing) === null || _userListData$getUser2 === void 0 ? void 0 : _userListData$getUser2.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  React.useEffect(function () {
    if (userListData !== null && userListData !== void 0 && userListData.getUserListing.length && userParameterCheck.length == 0) {
      var _userListData$getUser3, _userListData$getUser4;
      setUserParameterCheck([{
        label: userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser3 = userListData.getUserListing[0]) === null || _userListData$getUser3 === void 0 ? void 0 : _userListData$getUser3.displayName,
        value: userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser4 = userListData.getUserListing[0]) === null || _userListData$getUser4 === void 0 ? void 0 : _userListData$getUser4.userId
      }]);
    }
  }, [userListData]);
  React.useEffect(function () {
    var selectedUserIds = userParameterCheck === null || userParameterCheck === void 0 ? void 0 : userParameterCheck.map(function (user) {
      return user.value;
    });
    setUserActive(selectedUserIds);
  }, [userParameterCheck]);
  var columns = React.useMemo(function () {
    return [{
      Header: "Employee",
      accessor: "displayName"
    }, {
      Header: "Date",
      accessor: "date"
    }, {
      Header: "Start Time",
      accessor: "startTime"
    }, {
      Header: "End Time",
      accessor: "endTime"
    }, {
      Header: "Activity Duration",
      accessor: "reason"
    }];
  }, []);
  var csvData = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(exportDatas) {
      var wb, ws, buf, fileName;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!exportDatas || exportDatas.length === 0)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", []);
          case 2:
            wb = new Excel.Workbook();
            ws = wb.addWorksheet();
            ws.columns = [{
              header: "Employee",
              key: "displayName",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Date",
              key: "date",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Start Time",
              key: "startTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "End Time",
              key: "endTime",
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }, {
              header: "Activity Duration",
              key: "reason",
              width: 20,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            }];
            exportDatas.map(function (d, index) {
              var activityStart = d.activityStart,
                activityEnd = d.activityEnd,
                user = d.user,
                activityReason = d.activityReason,
                reason = d.reason,
                activity = d.activity,
                totalHours = d.totalHours;
              var reasons = activityEnd !== null ? activityReason !== null ? reason : "Worked for ".concat(totalHours !== null ? convertSecToHoursAndMinutesAndSecWithTextShortForm(Number(totalHours)) : "0h:0m") : activity === "start" ? "-" : reason;
              ws.addRow({
                displayName: user.displayName,
                date: moment(activityStart).format("DD MMMM YYYY"),
                startTime: activityStart !== null ? moment(activityStart).format("hh:mm A") : "-",
                endTime: activityEnd !== null ? moment(activityEnd).format("hh:mm A") : activity === "start" ? "Working On" : "-",
                reason: reasons
              });
            });
            ws.getCell("A1").font = {
              bold: true
            };
            ws.getCell("B1").font = {
              bold: true
            };
            ws.getCell("C1").font = {
              bold: true
            };
            ws.getCell("D1").font = {
              bold: true
            };
            ws.getCell("E1").font = {
              bold: true
            };
            _context.next = 13;
            return wb.xlsx.writeBuffer();
          case 13:
            buf = _context.sent;
            fileName = "workfolio-work-activity-log-".concat(moment(Number(startDate)).format("DD-MMM"), ".xlsx");
            if (endDate != null) {
              fileName = "workfolio-work-activity-log-".concat(moment(Number(startDate)).format("DD-MMM"), "-").concat(moment(Number(endDate)).format("DD-MMM"), ".xlsx");
            }
            saveAs(new Blob([buf]), fileName);
            setExportButton(false);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [exportData]);
  React.useEffect(function () {
    if (exportData && exportData !== null && exportData !== void 0 && exportData.breakTimeSummaryExport) {
      var dataValues = exportData === null || exportData === void 0 ? void 0 : exportData.breakTimeSummaryExport;
      if (exportLimit !== 0) {
        setAllUsersData(function (prev) {
          return [].concat(_toConsumableArray(prev), _toConsumableArray(dataValues));
        });
        if (loopInit < loopCount) {
          var nextLoop = loopInit + 1;
          var nextBatch = userActive.slice(loopInit * exportLimit, nextLoop * exportLimit);
          setTimeout(function () {
            setLoopInit(nextLoop);
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: "all",
                userId: nextBatch.length ? nextBatch : null,
                startDate: Number(moment(startDate).format("x")),
                endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
              }
            });
          }, 1000);
        }
        if (loopInit === loopCount) {
          csvData([].concat(_toConsumableArray(allUsersData), _toConsumableArray(dataValues)));
        }
      } else {
        csvData(dataValues);
      }
    }
  }, [exportData]);
  React.useEffect(function () {
    // userListRefetch?.();
    breakTimeSummaryRefetch === null || breakTimeSummaryRefetch === void 0 ? void 0 : breakTimeSummaryRefetch();
  }, [location.key]);
  React.useEffect(function () {
    offsets = 0;
  }, [startDate]);
  if (userListLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (userListError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!userListData) {
    return null;
  }
  var dataTable = breakTimeSummaryData === null || breakTimeSummaryData === void 0 ? void 0 : (_breakTimeSummaryData = breakTimeSummaryData.breakTimeSummary) === null || _breakTimeSummaryData === void 0 ? void 0 : _breakTimeSummaryData.map(function (d) {
    var activityStart = d.activityStart,
      activityEnd = d.activityEnd,
      user = d.user,
      activityReason = d.activityReason,
      reason = d.reason,
      activity = d.activity,
      totalHours = d.totalHours;
    return {
      date: moment(activityStart).format("DD MMMM YYYY"),
      displayName: user.displayName,
      startTime: activityStart !== null ? moment(activityStart).format("hh:mm A") : "-",
      endTime: activityEnd !== null ? moment(activityEnd).format("hh:mm A") : activity === "start" ? "Working On" : "-",
      reason: activityEnd !== null ? activityReason !== null ? reason : /*#__PURE__*/React.createElement(React.Fragment, null, "Worked ", /*#__PURE__*/React.createElement("span", {
        className: "personal-clockin-clockout-content-data-details-for"
      }, "for"), /*#__PURE__*/React.createElement("span", {
        className: "personal-clockin-clockout-content-data-details-worked-hours"
      }, totalHours !== null ? convertSecToHoursAndMinutesAndSecWithTextShortForm(Number(totalHours)) : "0h:0m")) : activity === "start" ? "-" : reason
    };
  });
  if ((breakTimeSummaryData === null || breakTimeSummaryData === void 0 ? void 0 : (_breakTimeSummaryData2 = breakTimeSummaryData.breakTimeSummary) === null || _breakTimeSummaryData2 === void 0 ? void 0 : _breakTimeSummaryData2.length) !== 0 && (breakTimeSummaryData === null || breakTimeSummaryData === void 0 ? void 0 : (_breakTimeSummaryData3 = breakTimeSummaryData.breakTimeSummary) === null || _breakTimeSummaryData3 === void 0 ? void 0 : _breakTimeSummaryData3.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  var handleLoadMore = function handleLoadMore() {
    if (breakTimeSummaryLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref2) {
        var _fetchMoreResult$brea, _fetchMoreResult$brea2;
        var fetchMoreResult = _ref2.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$brea = fetchMoreResult.breakTimeSummary) === null || _fetchMoreResult$brea === void 0 ? void 0 : _fetchMoreResult$brea.length) === 0 && ((_fetchMoreResult$brea2 = fetchMoreResult.breakTimeSummary) === null || _fetchMoreResult$brea2 === void 0 ? void 0 : _fetchMoreResult$brea2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          breakTimeSummary: [].concat(_toConsumableArray(prev.breakTimeSummary), _toConsumableArray(fetchMoreResult.breakTimeSummary))
        });
      }
    });
  };
  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  var getExportData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var userBatch;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setExportButton(true);
            setAllUsersData([]);
            setLoopInit(1);
            userBatch = userActive.slice(0, exportLimit || userActive.length);
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: "all",
                userId: userBatch.length ? userBatch : null,
                startDate: Number(moment(startDate).format("x")),
                endDate: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone
              }
            });
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getExportData() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "report-activity-summary-root"
  }, organisationBilling.planName != "free" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-filter-user"
  }, /*#__PURE__*/React.createElement(MultiSelect, {
    options: userList,
    value: userParameterCheck,
    onChange: function onChange(e) {
      setUserParameterCheck(e);
    },
    overrideStrings: {
      allItemsAreSelected: "All Members",
      selectAll: "All Members",
      selectSomeItems: "Select a Member"
    }
  })), /*#__PURE__*/React.createElement(Dropdown, {
    open: isNavClick,
    className: classNames("apps-usage-users-button .btn-primary")
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basics"
  }, arrayToStringOutput([startDate, endDate], organisationSettings.organisationTimezone)), /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "page-content-wrapper-menu-filter-overlay-trigger"
  }, /*#__PURE__*/React.createElement(TimeFilter, {
    onFilterChange: onFilterChange,
    startDate: startDate,
    endDate: endDate,
    filterData: filterData,
    onClose: hideOverlay,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings
  })))), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? !(breakTimeSummaryData !== null && breakTimeSummaryData !== void 0 && (_breakTimeSummaryData4 = breakTimeSummaryData.breakTimeSummary) !== null && _breakTimeSummaryData4 !== void 0 && _breakTimeSummaryData4.length) ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "daily-attendance-filter-download-icon-btn-disable"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    },
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " Export") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    className: "daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export")))), breakTimeSummaryLoading ? /*#__PURE__*/React.createElement(Loader, null) : breakTimeSummaryError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : userActive.length == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "Please select a member") : !(breakTimeSummaryData !== null && breakTimeSummaryData !== void 0 && (_breakTimeSummaryData5 = breakTimeSummaryData.breakTimeSummary) !== null && _breakTimeSummaryData5 !== void 0 && _breakTimeSummaryData5.length) ? /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "No activity found for this member") : /*#__PURE__*/React.createElement(TableGrid, {
    columns: columns,
    data: dataTable,
    handleLoadMore: handleLoadMore,
    isAllLoaded: isAllLoaded,
    isLoadingMore: isLoadingMore,
    userActive: userActive
  })) : /*#__PURE__*/React.createElement(PlanUpgradeMessage, {
    displayName: user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history
  })));
};
var TableGrid = function TableGrid(props) {
  var columns = props.columns,
    data = props.data,
    handleLoadMore = props.handleLoadMore,
    isAllLoaded = props.isAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    userActive = props.userActive;
  var _useTable = useTable({
      columns: columns,
      data: data
    }, useSortBy),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    rows = _useTable.rows,
    prepareRow = _useTable.prepareRow;
  return /*#__PURE__*/React.createElement("div", {
    className: "daily-attendance-content"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("table", _extends({}, getTableProps(), {
    className: "daily-attendance-table"
  }), /*#__PURE__*/React.createElement("thead", null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/React.createElement("tr", headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      // Add the sorting props to control sorting. For this example
      // we can add them into the header props
      //console.log("column", column);
      return /*#__PURE__*/React.createElement("th", column.getHeaderProps(column.getSortByToggleProps()), column.render("Header"), /*#__PURE__*/React.createElement("span", null, column.isSorted ? column.isSortedDesc ? /*#__PURE__*/React.createElement(HiChevronDown, {
        className: "app-usage-datas-thead-sort-icon"
      }) : /*#__PURE__*/React.createElement(HiChevronUp, {
        className: "app-usage-datas-thead-sort-icon"
      }) : /*#__PURE__*/React.createElement(HiOutlineSelector, {
        className: "app-usage-datas-thead-sort-icon"
      })));
    }));
  })), /*#__PURE__*/React.createElement("tbody", getTableBodyProps(), rows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement("tr", row.getRowProps(), row.cells.map(function (cell) {
      return /*#__PURE__*/React.createElement("td", cell.getCellProps(), cell.render("Cell"));
    }));
  }), !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null))), /*#__PURE__*/React.createElement("td", null)) : /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    },
    className: "daily-attendance-table-load-more-btn"
  }, "Load more")), /*#__PURE__*/React.createElement("td", null))) : userActive.length == 0 ? /*#__PURE__*/React.createElement("tr", {
    className: "daily-attendance-table-load-more-tr"
  }, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
    colSpan: 6,
    className: "daily-attendance-table-load-more-td"
  }, /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the member")), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)) : null))));
};
export default WorkActivityLog;